import axios from "axios";

export const GoogleAPIKey = "AIzaSyC7HQkfJkwVLGTsvUwAIy4JH3bdlE7fyzE";

const ADMIN_TOKEN = "24nh9ljk0a23YlkJUlweF2ci5jseCqpie29si";
export function attemptSignIn(data) {
  const apiUrl = process.env.REACT_APP_API_URL;
  // return axios.request({
  // 	url: `${apiUrl}/token/`,
  // 	method: 'POST',
  // 	withCredentials: true,
  // 	headers: {
  // 		Accept: 'application/json',
  // 		'Content-Type': 'application/json',
  // 	},
  // 	data,
  // });
  return {
    access: "Access",
    refresh: "Refresh",
  };
}

export function getCurrentUserDetail(token) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const header = `Bearer ${token}`;
  return axios.request({
    url: `${apiUrl}/users/me/`,
    method: "GET",
    withCredentials: true,
    headers: {
      Accept: "application/json",
      Authorization: header,
    },
  });
}
export const getaddress = async (postcode) => {
  try {
    let url = "";
    url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postcode}&key=${GoogleAPIKey}`;
    let response = await fetch(url, {
      method: "GET",
    });
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};
export const inviteTasker = async (firstName, brandName, phoneNumber, uid) => {
  try {
    let url = "";
    url = `https://apricot-mole-2227.twil.io/invite-tasker?phoneNumber=${phoneNumber}&firstName=${firstName}&brandName=${brandName}&token=${uid}`;
    let response = await fetch(url, {
      method: "GET",
    });
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};

export const inviteReview = async (firstName, brandName, phoneNumber, uid) => {
  try {
    let url = "";
    url = `https://apricot-mole-2227.twil.io/invite-review?phoneNumber=${phoneNumber}&firstName=${firstName}&brandname=${brandName}&uid=${uid}`;
    let response = await fetch(url, {
      method: "GET",
    });
    let res = await response.json();
    console.log("res", res);
    return res;
  } catch (err) {
    return err;
  }
};

export const removeTaskerFromAuth = (uid) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-removeUserById",
    {
      uid,
      token: ADMIN_TOKEN,
    }
  );
};

export const createRetailerLeadAdmin = (email, password) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-createUser",
    {
      email,
      password,
      token: ADMIN_TOKEN,
    }
  );
};

export const sendResetPassword = (email, firstName, retailerName, password) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-sendRestPasswordEmail",
    {
      to: email,
      password,
      firstName,
      retailerName,
      token: ADMIN_TOKEN,
    }
  );
};

export const sendUmbrellaPasswordEmail = (
  email,
  firstName,
  brand,
  password
) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-sendEcosystemAdminRestPasswordEmail",
    {
      to: email,
      password,
      firstName,
      brand,
      token: ADMIN_TOKEN,
    }
  );
};

export const sendInvestorResetPasswordEmail = (email, firstName, password) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-sendInvestorPasswordEmail",
    {
      to: email,
      password,
      firstName,
      token: ADMIN_TOKEN,
    }
  );
};

export const updateRetailerAdminLead = (uid, email) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-updateUser",
    {
      uid,
      email,
      token: ADMIN_TOKEN,
    }
  );
};

export const getUsers = (ids) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-getUsers",
    {
      ids,
      token: ADMIN_TOKEN,
    }
  );
};
export const getAgencyEmailbyUID = async (uid) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-getAgencyEmailbyUID",
    {
      uid: uid,
    }
  );
};
export const resetPassword = (uid, password) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-resetPassword",
    {
      uid,
      password,
      token: ADMIN_TOKEN,
    }
  );
};

export const sendBrandAdminRegistrationEmail = (brand, brand_admin) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-sendBrandAdminRegistrationEmail",
    { brand, brand_admin }
  );
};

export const sendBrandAdminPasswordEmail = (
  email,
  firstName,
  brand,
  password
) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-sendEcosystemBrandRestPasswordEmail",
    {
      to: email,
      password,
      firstName,
      brand,
      token: ADMIN_TOKEN,
    }
  );
};

export const sendBrandAdminTicketCreationEmail = (brand, username, email) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/ecosystem-sendBrandAdminTicketCreationEmail",
    {
      brand,
      username,
      email,
    }
  );
};

export const getEsignEmbbedUrl = (
  email,
  firstName,
  lastName,
  companyName,
  companyNumber,
  companyAddress,
  brandName,
  commencementDate,
  userCost,
  userCommitment,
  type = "trial"
) => {
  return axios.post(
    "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/esign-embededSessionUrl",
    {
      companyName,
      companyNumber,
      companyAddress,
      firstName,
      lastName,
      email,
      type,
      token: ADMIN_TOKEN,
      brandName,
      commencementDate,
      userCost,
      userCommitment,
    }
  );
};



// WEBPACK FOOTER //
// ./src/api/UserApi.js